module.exports = __webpack_public_path__ + "img/8c65458.jpg";